import { extendTheme, theme as chakraTheme } from '@chakra-ui/react'

import { baseColorScheme } from './base-color-scheme'
import { baseTheme } from './base-theme'
import styles from './custom-styles'

const theme = extendTheme(baseTheme, baseColorScheme, chakraTheme, styles)

export default theme
